import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from '@doxyme/ui';
import { FormattedMessage } from 'react-intl';
import './leave-modal.scss';
export const LeaveModal = ({ isOpen, title, message, continueText, onContinue, onLeave, }) => {
    return (<Modal className="teleconsent-leave-modal" isOpen={isOpen}>
      <ModalHeader>
        <h4>{title}</h4>
      </ModalHeader>
      <ModalBody>{message}</ModalBody>
      <ModalFooter>
        <div className="ui-modal-actions">
          <Button size="medium" onClick={onLeave} btnStyle="outline" color="secondary" data-testId="leave-modal-anyway-btn">
            <FormattedMessage id="apps.teleconsent.action.leave.anyway"/>
          </Button>
          <Button size="medium" onClick={onContinue} data-testId="leave-modal-continue-btn">
            {continueText}
          </Button>
        </div>
      </ModalFooter>
    </Modal>);
};
